import React, { useEffect } from 'react';
import { Container, Group, Box, Text, ActionIcon, Stack, Button, Flex } from '@mantine/core';
import { Link } from '@inertiajs/react';
import { useMediaQuery } from '@mantine/hooks';
import { IconBrandFacebook, IconBrandInstagram, IconBrandYoutube } from '@tabler/icons-react';
import newLogoWhite from '@/assets/images/new-wcwd-logo-white.svg';

const Footer = () => {
  useEffect(() => {
    const fixFooterPosition = () => {
      const appContainer = document.querySelector('.app-container') || document.querySelector('#app');
      const footer = document.querySelector('footer');
      const mainContent = document.querySelector('main') || document.querySelector('.main-content');

      if (!footer || !appContainer) return;

      if (mainContent && footer.compareDocumentPosition(mainContent) & Node.DOCUMENT_POSITION_FOLLOWING) {
        appContainer.appendChild(footer);
      }

      footer.style.marginTop = 'auto';
      footer.style.width = '100%';
    };

    setTimeout(fixFooterPosition, 100);
    window.addEventListener('popstate', fixFooterPosition);

    return () => {
      window.removeEventListener('popstate', fixFooterPosition);
    };
  }, []);

  const isMobile = useMediaQuery('(max-width: 576px)');
  const isTablet = useMediaQuery('(min-width: 577px) and (max-width: 768px)');
  const isDesktop = useMediaQuery('(min-width: 769px)');

  return (
    <Box
      component="footer"
      bg="#09090B"
      py="md"
      style={{ color: 'white', width: '100%', height: 'auto', marginTop: 'auto' }}
    >
      <Container size="lg">
        {(isDesktop || isTablet || isMobile) && (
          <Flex justify="space-between" gap="md" mb="8rem" direction={isTablet || isMobile ? 'column' : 'row'}>
            <Stack gap="lg" align={isMobile ? 'flex-start' : 'flex-start'}>
              <Box>
                <img
                  src={newLogoWhite}
                  alt="Where Can We Dance Logo"
                  style={{ marginTop: '12px', height: isMobile ? '30px' : '40px', width: 'auto' }}
                />
              </Box>
              <Box>
                <Text mb="md" size="md" fw={700} c="#f2f2f290" ta={isMobile ? 'center' : 'left'}>
                  Follow Us
                </Text>
                <Group gap="xs" justify={isMobile ? 'center' : 'flex-start'}>
                  <a href="https://www.facebook.com/wherecanwedance" target="_blank" rel="noopener noreferrer">
                    <ActionIcon size="lg" variant="subtle" color="gray">
                      <IconBrandFacebook size={22} />
                    </ActionIcon>
                  </a>
                  <a href="https://www.instagram.com/where.can.we.dance/" target="_blank" rel="noopener noreferrer">
                    <ActionIcon size="lg" variant="subtle" color="gray">
                      <IconBrandInstagram size={22} />
                    </ActionIcon>
                  </a>
                  <a href="https://www.youtube.com/@WhereCanWeDance" target="_blank" rel="noopener noreferrer">
                    <ActionIcon size="lg" variant="subtle" color="gray">
                      <IconBrandYoutube size={22} />
                    </ActionIcon>
                  </a>
                </Group>
              </Box>
            </Stack>

            <Flex gap="xl" direction={isMobile ? 'column' : 'row'} align={isMobile ? 'flex-start' : 'flex-start'}>
              <Box>
                <Text className="my-3" mb="18px" size="1rem" fw={700} c="#f2f2f290" ta={isMobile ? 'center' : 'left'}>
                  Quick Links
                </Text>
                <Stack gap="lg" align={isMobile ? 'flex-start' : 'flex-start'}>
                  <Text component={Link} href="/artist-stars" size="0.9rem" c="gray.3">
                    Artist Stars
                  </Text>
                  <a
                    href="https://www.wherecanwedance.com/feedback"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                  >
                    <Text size="0.9rem" c="gray.3">
                      Feedback
                    </Text>
                  </a>
                  <a
                    href="https://help.wherecanwedance.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                  >
                    <Text size="0.9rem" c="gray.3">
                      Help center
                    </Text>
                  </a>
                  <Text component={Link} href="#" size="0.9rem" c="gray.3">
                    Contact us
                  </Text>
                </Stack>
              </Box>

              <Box>
                <Text className="my-3" size="1rem" fw={700} c="#f2f2f290" ta={isMobile ? 'left' : 'left'}>
                  Resources
                </Text>
                <Stack gap="md" align={isMobile ? 'flex-start' : 'flex-start'}>
                  <a
                    href="https://www.wherecanwedance.com/suggest_artist"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                  >
                    <Text size="0.9rem" c="gray.3">
                      Add A New Artist
                    </Text>
                  </a>
                  <a
                    href="https://www.wherecanwedance.com/suggest_event"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                  >
                    <Text size="0.9rem" c="gray.3">
                      Add A New Event
                    </Text>
                  </a>
                  <Text component={Link} href="#" size="0.9rem" c="gray.3">
                    Community Guidelines
                  </Text>
                  <Text component={Link} href="#" size="0.9rem" c="gray.3">
                    Terms & Privacy
                  </Text>
                  <Text component={Link} href="#" size="0.9rem" c="gray.3">
                    GDPR
                  </Text>
                </Stack>
              </Box>
            </Flex>

            <Stack gap="xl" style={{ maxWidth: '300px' }} align={isMobile ? 'flex-start' : 'flex-start'}>
              <Box>
                <Text className="my-3" size="1rem" fw={700} c="#f2f2f290" ta={isMobile ? 'left' : 'left'}>
                  Newsletter
                </Text>
                <Text size="0.9rem" c="gray.3" ta={isMobile ? 'left' : 'left'}>
                  Be the first to know about our future updates!
                </Text>
                <Button
                  component="a"
                  href="/subscribe"
                  variant="filled"
                  color="#EA580C"
                  className="mt-3"
                  radius="md"
                  size="lg"
                  fullWidth
                >
                  Subscribe
                </Button>
              </Box>
              <Box>
                <Text className="my-3" size="1rem" fw={700} c="#f2f2f290" ta={isMobile ? 'left' : 'left'}>
                  Support this project
                </Text>
                <Text size="0.9rem" c="gray.3" ta={isMobile ? 'left' : 'left'}>
                  We're consistently working on new releases.
                </Text>
                <Button
                  component="a"
                  href="/support"
                  variant="filled"
                  color="#EA580C"
                  className="mt-3"
                  radius="md"
                  size="lg"
                  fullWidth
                >
                  Donate a star!
                </Button>
              </Box>
            </Stack>
          </Flex>
        )}
      </Container>
    </Box>
  );
};

export default Footer;
